<template>
    <div class="content">
      
        <el-row class="bgW">
            <el-col :span="22">
            <!-- 检索条件 -->
            <el-form class="search" :inline="true" size="mini" :model="search">
                <el-form-item label="问卷名称">
                    <el-input 
                        v-model="search.title" 
                        placeholder="请输入问卷名称" 
                        clearable
                        class="w180"
                    ></el-input>
                </el-form-item>
                
                <el-form-item label="适用人群">
                    <el-input 
                        v-model="search.participants" 
                        placeholder="请输入适用人群" 
                        clearable
                        class="w180"
                    ></el-input>
                </el-form-item>
                
                <el-form-item label="是否弹窗">
                    <el-select v-model="search.is_popup" clearable class="w120">
                        <el-option
                        v-for="item in options.isPopup"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="search.create_start"
                        type="date"
                        class="w130"
                        placeholder="开始日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="search.create_end"
                        type="date"
                        class="w130"
                        placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="活动开始时间">
                    <el-date-picker
                        v-model="search.start_time"
                        type="date"
                        class="w130"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="活动结束时间">
                    <el-date-picker
                        v-model="search.end_time"
                        type="date"
                        class="w130"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            </el-col>
            <el-col :span="2" style="text-align: right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
            </el-col>
        </el-row>
  
        <div class="accountCon">
             <div class="btnBox">
                <el-button
                    type="primary"
                    class="mb10"
                    size="mini"
                    icon="el-icon-plus"
                    @click="handle('','add')"
                >新增问卷</el-button>
            </div>      
            <!-- 列表 -->
            <el-row>
                <el-col :span="24">
                    <el-table
                        :data="list"
                        size="small"
                        border
                        :cell-style="$style.cellStyle"
                        :header-cell-style="$style.rowClass"
                        v-loading="loading"
                        element-loading-text="加载中..."
                    >
                        <ElTableColumn label="序号" type="index" width="55" />
                        <el-table-column label="问卷名称" prop="title" min-width="200" />
                        <el-table-column label="开始时间" prop="start_time" width="180" align="center" />
                        <el-table-column label="结束时间" prop="end_time" width="180" align="center" />
                        <el-table-column label="参与人数" prop="participants_count" width="100" align="center" />
                        <el-table-column label="弹窗设置" prop="is_popup" width="100" align="center" />
                        <el-table-column label="时间状态" prop="time_status" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="getTimeStatusType(scope.row.time_status)">
                                    {{ scope.row.time_status }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" prop="status" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="getStatusType(scope.row.status)">
                                    {{ scope.row.status }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" prop="operator_name" width="120" align="center" />
                        <el-table-column label="创建时间" prop="create_time" width="180" align="center" />
                               <el-table-column label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                  <el-button 
                                    size="mini" 
                                    type="text" 
                                    @click="handle(scope.row,'export')"
                                    class="view-btn"
                                >
                                    导出
                                </el-button>
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    @click="handle(scope.row,'detail')"
                                    class="view-btn"
                                >
                                    查看
                                </el-button>
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    @click="handle(scope.row,'edit')"
                                    class="edit-btn"
                                >
                                    编辑
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination
                        class="page tc mt10"
                        :total="page.total"
                        :page.sync="page.page"
                        :limit.sync="page.page_size"
                        @pagination="getList"
                    />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import { getSurveyList,surveyListExport } from "@/api/sys";
  
// 搜索条件类
class Search {
    title = "";               // 问卷名称
    participants = "";        // 适用人群
    is_popup = "";            // 是否弹窗
    create_start = "";        // 创建开始时间
    create_end = "";          // 创建结束时间
    start_time = "";          // 活动开始时间
    end_time = "";            // 活动结束时间
}

// 选项数据类
class Options {
    isPopup = [
        { id: 1, name: "否" },
        { id: 2, name: "是" }
    ];
}

// 分页类
class Page {
    total = 0;
    page = 1;
    page_size = 10;
}

export default {
    name: "QuestionnaireList",
    components: {
        pagination
    },
    data() {
        return {
            search: new Search(),
            options: new Options(),
            page: new Page(),
            list: [],
            loading: false
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList(option) {
            this.loading = true;
            if (option === "search") {
                this.page = new Page();
            }
            
            getSurveyList({ ...this.search, ...this.page, is_export: 0 }).then(
                res => {
                    this.list = res.data;
                    this.page.total = res.total;
                    this.loading = false;
                }
            ).catch(() => {
                this.loading = false;
                this.$message.error("网络错误，获取数据失败");
            });
        },
        handle(row,type) {
            if (type === 'add') {
                this.$router.push({ name: '新增/编辑问卷' });
            } else if (type === 'detail') {
                this.$router.push({ name: '问卷详情', query: { id: row.id } });
            } else if (type === 'edit') {
                this.$router.push({ name: '新增/编辑问卷', query: { id: row.id } });
            } else if (type === 'export') {
                surveyListExport({ survey_id: row.id }).then(
                    res => {
                         window.open(res.url);
                    }
                ).catch(() => {
                    this.$message.error('导出失败');
                });
            }
        },

        // 根据状态获取标签类型
        getStatusType(status) {
            switch(status) {
                case "上架": return "success";
                case "下架": return "warning";
                default: return "info";
            }
        },

        // 根据时间状态获取标签类型
        getTimeStatusType(timeStatus) {
            switch(timeStatus) {
                case "进行中": return "primary";
                case "未开始": return "info";
                case "已结束": return "danger";
                default: return "info";
            }
        }
    }
};
</script>
  
<style lang="scss" scoped>
.mainColor {
    color: #2dc0a3;
}
.bgW {
    background: #fff;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 20px;
}
  
.el-form-item {
    margin: 5px 10px 3px 0;
}
.accountCon {
    background: #fff;
    padding: 15px;
    border-radius: 3px;
}

.page {
    margin-top: 15px;
}

::v-deep .el-descriptions__body {
    padding-top: 10px;
}

::v-deep .el-descriptions-item {
    padding: 12px 10px;
}
</style>
    